import '../styles/footer.css';

export default function Footer(){
    return(
        <div className="footer-main">
            <h5>DC Creations Inc.</h5>
        </div>
    )
}